import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PropertyService } from '../../../_services/properties/property.service';
import { ToastService } from '../../../_services/toast.service';
import { ScrollingModule } from '@angular/cdk/scrolling';

interface Cluster {
  cluster: string;
  _id:string,
  createdAt:string
}

interface MicroMarket {
  name: string;
  cluster: string;
}

@Component({
  selector: 'app-property-values',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,ScrollingModule],
  templateUrl: './property-values.component.html',
})
export class PropertyValuesComponent implements OnInit {
  clusterForm!: FormGroup;
  microMarketForm!: FormGroup;
  cluster: Cluster[] = [];
  constructor(
    private _PS: PropertyService,
    private _fb: FormBuilder,
    private _NS: ToastService
  ) {}

  ngOnInit(): void {
    this.getAllClusterName();
    this.getMicroMarkets();
    this.formControl();
    this.createForm();
  }
  formControl() {
    this.clusterForm = this._fb.group({
      newCluster: ['', Validators.required],
      clusters: this._fb.array([]),
    });
  }
 

  get clusters(): FormArray {
    return this.clusterForm.get('clusters') as FormArray;
  }

  addCluster(): void {
    const clusterName = this.clusterForm.get('newCluster')?.value?.trim();
    if (!clusterName) return;
    this.clusters.push(
      this._fb.group({
        cluster: [clusterName],
      })
    );
    this.clusterForm.get('newCluster')?.reset();
  }

  removeCluster(index: number): void {
    this.clusters.removeAt(index);
  }
  submitClusters(): void {
    this._PS.addClusters(this.clusterForm.value.clusters).subscribe({
      next: (res: any) => {
        this._NS.success(`${res.addedCount} Cluster added.`);
        this.clusterForm.reset();
        this.clusters.clear();
        this.getAllClusterName();
      },
      error: (err: any) => {
        this._NS.error(err.message);
      },
    });
  }
  createForm(): void {
    this.microMarketForm = this._fb.group({
      micromarketName: ['', Validators.required],
      cluster: ['', Validators.required],
      microMarkets: this._fb.array([]),
    });
  }
  get microMarkets(): FormArray {
    return this.microMarketForm.get('microMarkets') as FormArray;
  }

  addMicroMarket(): void {
    if (
      this.microMarketForm.get('micromarketName')?.invalid ||
      this.microMarketForm.get('cluster')?.invalid
    ) {
      this.microMarketForm.markAllAsTouched();
      return;
    }

    this.microMarkets.push(
      this._fb.group({
        micromarketName: [this.microMarketForm.get('micromarketName')?.value],
        cluster: [this.microMarketForm.get('cluster')?.value],
      })
    );

    this.microMarketForm.patchValue({
      micromarketName: '',
      cluster: '',
    });
  }

  removeMicroMarket(index: number): void {
    this.microMarkets.removeAt(index);
  }
  submitMicroMarkets(): void {
    console.log(this.microMarketForm.value.microMarkets);
    this._PS.addMicroMarket(this.microMarketForm.value.microMarkets).subscribe({
      next: (res: any) => {
        this._NS.success(`${res.count} Micro Market added in slected cluster.`);
        this.microMarketForm.reset();
        this.microMarkets.clear();
        this.getAllClusterName();
        this.getMicroMarkets();

      },
      error: (err: any) => {
        this._NS.error(err.message);
      },
    });
  }
micromarkets:any = [ ];
searchQuery = '';
searchQueryCluster= ''
get filteredCluster() {
  const q = this.searchQueryCluster.toLowerCase();
  return this.cluster.filter((m:any) =>
    m.cluster.toLowerCase().includes(q)
  );
}
getAllClusterName() {
  this._PS.findAllClusters().subscribe((res: any) => {
    this.cluster = res.reverse();
  });
}
get filtered() {
  const q = this.searchQuery.toLowerCase();
  return this.micromarkets.filter((m:any) =>
    m.micromarketName.toLowerCase().includes(q) ||
    m.cluster.toLowerCase().includes(q)
  );
}
getMicroMarkets(){
  this._PS.getAllMircoMarketReq().subscribe((res:any)=>{
    this.micromarkets = res.reverse()
  })
}
}
